/// <amd-module name="TFS/Admin/Views/AdminRoles/Redux/AdminRolesSelectors" />
import { IAdminRolesAwareState } from "TFS/Admin/Views/AdminRoles/Contracts";

export function getLoading(state: IAdminRolesAwareState): boolean {
    if (!state || !state.adminRolesState.loading) {
        return true;
    }

    return state.adminRolesState.loading;
}
